import React, { useState } from 'react';

const TabLikeComponent = () => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div className="p-4">
      {/* Tabs */}
      <div className="flex space-x-2 mb-4">
        {['Solicitud', 'Asignación'].map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index + 1)}
            className={`px-4 py-2 rounded-t ${
              activeTab === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="border p-4 bg-white rounded-b shadow">
        {activeTab === 1 && (
          <div>
            <h2 className="text-lg font-semibold mb-2">Hoja 1</h2>
            <input
              type="text"
              placeholder="Campo 1"
              className="block border rounded mb-2 p-2 w-full"
            />
            <input
              type="text"
              placeholder="Campo 2"
              className="block border rounded mb-2 p-2 w-full"
            />
            <input
              type="text"
              placeholder="Campo 3"
              className="block border rounded mb-2 p-2 w-full"
            />
          </div>
        )}
        {activeTab === 2 && (
          <div>
            <h2 className="text-lg font-semibold mb-2">Hoja 2</h2>
            <label className="block mb-2">Label para el campo:</label>
            <input
              type="text"
              placeholder="Campo único"
              className="block border rounded mb-4 p-2 w-full"
            />
            <table className="table-auto w-full border-collapse border border-gray-300">
              <thead>
                <tr>
                  <th className="border border-gray-300 px-4 py-2">Columna 1</th>
                  <th className="border border-gray-300 px-4 py-2">Columna 2</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Dato 1</td>
                  <td className="border border-gray-300 px-4 py-2">Dato 2</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabLikeComponent;
